import React from "react";
import {
  Dialog,
  DialogContent,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import { fileUrl } from "../../Config/Config";
import ClearIcon from "@mui/icons-material/Clear";

export default function ImagesDialog({ open, setOpen, data }) {
  const images = Array.isArray(data?.pictureUrl)
    ? data.pictureUrl
    : data?.pictureUrl
    ? [data.pictureUrl]
    : [];

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      maxWidth="sm"
      fullWidth
      BackdropProps={{
        sx: {
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
        <ClearIcon
          sx={{ cursor: "pointer" }}
          onClick={() => setOpen(false)}
        />
      </Box>
      <DialogContent>
        {images.length > 0 ? (
          <Grid container spacing={2}>
            {images.map((img, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <img
                  src={img?.startsWith("http") ? img : fileUrl + img}
                  alt={`preview-${index}`}
                  style={{ width: "100%", height: "auto", borderRadius: 8 }}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography align="center" variant="h6" color="textSecondary">
            No images found
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}
